module.exports = __webpack_public_path__ + "img/marker1.5c733417.png";